// extracted by mini-css-extract-plugin
module.exports = {"buttonsContainer":"OnGoingPaymentBox_buttonsContainer__3yibI","resendInfoText":"OnGoingPaymentBox_resendInfoText__27TNJ"};